import ExamsRepository from '../../domain/repositories/ExamsRepository';
import ExamsDataStoreFactory from '../factories/ExamsDataStoreFactory';
import ExamsDataStore from '../datastores/ExamsDataStore';

export default class ExamsDataRepository implements ExamsRepository {
  getExams(period: string) {
    const examsDataStore: ExamsDataStore = ExamsDataStoreFactory.create();
    const exams = examsDataStore.getExams(period);
    return exams;
  }
}
